import React from "react";
import Logo from "../Img/logo.png";
import Axios from 'axios'
import {handleLogout} from "../Utils/auth";
import { Link } from 'react-router-dom';

export class MeusPremios extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user"))
    };
    this.listarPremiosDoCliente();
  }

  logout(){
    window.localStorage.setItem("rotaAtual", "");
    this.props.history.push('/')
}

  getUser = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/user", {
        id: this.state.user._id
      });

      window.localStorage.setItem("user", JSON.stringify(response.data[0]));
      this.setState({ user: response.data[0] });
    } catch (err) {
      console.log(err);
    }
  };

  listarPremiosDoCliente = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post(
        "gabaritos/premios-por-ganhador",
        {
          ganhadorId: this.state.user._id
        }
      );
      this.setState({ cartelas: response.data });
      console.log(this.state.cartelas);
    } catch (err) {
      console.log(err);
    }
  };
  async  reload(){
    await window.location.reload()
  }
  
  render() {
  
    const logout = () => {
      window.localStorage.removeItem('user')
      window.localStorage.removeItem("rotaAtual");
      window.location.href = '/'
  }
       const removeToggled = (e) => {
           window.localStorage.setItem("rotaAtual", e.target.name);
           setTimeout(this.reload, 100)
       }
   
    return (      <div>
      <div class="wrapper">
        <div class="sidebar" data-image="/assets/img/sidebar-5.jpg">
          <div class="sidebar-wrapper">
            <div class="logo">
              <img src={Logo} style={{ width: "10em", height: "4em" }} />
            </div>

            <ul class="nav">
            <li class="nav-item">
                <Link onClick={logout} className="nav-link" >
                    <i class="fas fa-sign-out-alt"></i>
                            <span>SAIR</span>
                  </Link>
                </li>
              <li class="nav-item">
                <Link class="nav-link" to="minhas-cartelas"  name="minhas-cartelas" onClick={removeToggled.bind(this)}>
                  <i class="nc-icon nc-layers-3"></i>
                  <p>Minhas cartelas</p>
                </Link>
              </li>
              <li>
                <Link class="nav-link" to="loja-cliente"  name="loja-cliente" onClick={removeToggled.bind(this)}>
                  <i class="nc-icon nc-istanbul"></i>
                  <p>Loja</p>
                </Link>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="ganhadores" name="ganhadores" onClick={removeToggled.bind(this)}>
                  <i class="nc-icon nc-satisfied"></i>
                  <p>ult. ganhadores</p>
                </Link>
              </li>
              <li>
                <Link class="nav-link" to="perfil-cliente" name="perfil-cliente" onClick={removeToggled.bind(this)}>
                  <i class="nc-icon nc-circle-09"></i>
                  <p>Perfil</p>
                </Link>
              </li>
              <li style={{padding: '8px'}}>
                  <Link style={{border: '3px solid white', borderRadius: '6px'}} class="nav-link"  name="aplicativo" onClick={() => {window.location.href = "https://www.sorteflash.com/download/sorteflash-app.apk"}}>
                    <i class="fa fa-android"></i> 
                    <p>Novo aplicativo</p>
                  </Link>
                </li>
            </ul>
          </div>
        </div>
        <div class="main-panel">
          <nav class="navbar navbar-expand-lg " color-on-scroll="500">
            <div class="container-fluid">
              <Link class="navbar-brand" to="#">
                {" "}
                Ganhadores{" "}
              </Link>
              <button
                to=""
                class="navbar-toggler navbar-toggler-right"
                type="button"
                data-toggle="collapse"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-bar burger-lines"></span>
                <span class="navbar-toggler-bar burger-lines"></span>
                <span class="navbar-toggler-bar burger-lines"></span>
              </button>
              <div
                class="collapse navbar-collapse justify-content-end"
                id="navigation"
              >
                <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <Link class="nav-link">
                        <span class="no-icon">{window.screen.width >= 600? "Olá, " + this.state.user.perfil.toLowerCase() + " " + this.state.user.nome : "Olá, " + this.state.user.nome }</span>
                    </Link>
                  </li>
                  {/* <li class="nav-item">
                    <Link class="nav-link" onClick={this.logout}>
                      <span class="no-icon">Sair</span>
                    </Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </nav>
          <div class="content">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <div class="card strpied-tabled-with-hover">
                    <div class="card-header ">
                      <h4 class="card-title">
                        Todos os ganhadores da semana
                      </h4>
                      <p class="card-category">
                        Informações dos premios da rodada.
                      </p>
                    </div>
                    <div class="card-body table-full-width table-responsive">
                      <table class="table table-hover table-striped">
                        <thead>
                          <tr>
                                        <th>Data</th>
                                          <th>Ganhador</th>
                                          <th>Vendedor</th>
                                          <th>Tipo de batida</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      {this.state.cartelas != null
                                          ? this.state.cartelas.map((item) => {
                                              return (
                                                  <tr>
                                                      <td>{this.formatDate(item.data)}</td>
                                                      <td>{item.ganhadorId ? item.ganhadorId.nome : "Desconhecido"}</td>
                                                      <td>{item.cambistaId ? item.cambistaId.nome : "Desconhecido"}</td>
                                                      <td>{item.tipo}</td>
                                                  </tr>
                                              );
                                          })
                                          : ""}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="footer">
            <div class="container-fluid">
              <nav>
                <ul class="footer-menu">
                  <li>
                    <Link to="#">Empresa</Link>
                  </li>
                  <li>
                    <Link to="#">Regulamento</Link>
                  </li>
                  <li>
                    <Link to="#">Outros projetos</Link>
                  </li>
                </ul>
                <p class="copyright text-center">
                  Proprietário ©
                  <Link to="https://www.instagram.com/sorteflash/">SorteFlash</Link>
                </p>
              </nav>
            </div>
          </footer>
        </div>
      </div>
    </div>
    );
  }
}

export default MeusPremios;
